import constant from "../../constant";
import axios from "axios";
import router from "../../router";
import { printData } from "../../utils/printUtils";
const api = constant.api + "invoices";
// initial state
const state = () => ({
  all: [],
  invoices: [],
  invoice: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getInvoice: (state) => {
    return state.invoice;
  },

  getInvoices: (state) => {
    return state.invoices;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let invoices = response.data;
      commit("setInvoices", invoices);
    });
  },

  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let invoice = response.data;
      commit("setInvoice", invoice);
    });
  },

  async store({ commit, dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({
          name: "invoices-index",
        });
      }
    });

    // try {
    //   dispatch(
    //     "notification/storeDownloading",
    //     { status: "success", message: "downloading..." },
    //     { root: true }
    //   );
    //   const response = await axios
    //     .post(api, data, {
    //       responseType: "blob", // Set the response type to 'blob' to handle binary data
    //     })
    //     .then((response) => {
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "Facture.pdf");
    //       link.click();
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    // } catch (error) {
    //   console.error(error);
    // }
  },

  async update({ dispatch }, data) {
    await axios.put(api + "/" + data.reference, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "invoices-index",
        });
      }
    });
  },

  async destroy({ commit }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let status = response.data.status;
      let invoices = response.data.data;
      if (status == "success") commit("setInvoices", invoices);
    });
  },

  async print({ dispatch }, reference) {
    try {
      await printData([], `${api}_print_page`, "GET", reference);

      // dispatch(
      //   { status: "success", message: "downloading..." },
      //   { root: true }
      // );
      // const response = await axios
      //   .get(api + "_print_page/" + reference, {
      //     responseType: "blob", // Set the response type to 'blob' to handle binary data
      //   })
      //   .then((response) => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", "Facture.pdf");
      //     link.click();
      //   })
      //   .catch((error) => {
      //     console.error(error);
      // });
    } catch (error) {
      console.error(error);
    }
  },

  async exportInvoices({ commit }, data) {
    try {
      const response = await this.$api.create(api + "_export", data, {
        responseType: "blob", // Important for file downloads
        headers: {
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `invoices_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
      document.body.appendChild(link);
      link.click();

      return { success: true };
    } catch (error) {
      return { success: false, error: error.response };
    }
  },

  async filter({ commit }, data) {
    await this.$api
      .create(api + "_filter", data, { confirm: false })
      .then((response) => {
        commit("setInvoices", response.data);
      });
  },
};

// mutations
const mutations = {
  setInvoices(state, invoices) {
    state.all = invoices;
    state.invoices = invoices;
  },
  setInvoice(state, invoice) {
    state.invoice = invoice;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.invoices = state.all.filter(function (invoice) {
      return (
        invoice.firstName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        invoice.lastName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        invoice.phone.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        invoice.reference.toUpperCase().indexOf(value.toUpperCase()) > -1
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
